<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Create Partner</div>
        <div>
          <bread-crumb :bread-crumbs="['Create Partner']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <!-- <v-btn @click="exportpdf()"> Export Pdf </v-btn> -->
      <v-card-text>
        <v-tabs color="primary" v-model="tabSeleted" slider-color="primary">
          <v-tab
            v-for="item in filteredTabs"
            :key="item.key"
            :href="'#' + item.key"
            :disabled="item.disabled"
            color="white"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabSeleted">
          <!-- <v-tab-item id="partner">
            <Companydetails @companyDetails="companyDetails" />
          </v-tab-item> -->
          <v-tab-item id="partner">
            <Companydetails @companyDetails="companyDetails" />
          </v-tab-item>
          <v-tab-item id="others">
            <Otherdetails :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
          <v-tab-item id="settlements">
            <SettlementsdetailsVue :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
          <v-tab-item id="remarks">
            <!-- <Remarks :getCompanyDetails="getCompanyDetails" /> -->
          </v-tab-item>
          <v-tab-item id="payment"
            ><paymentMode :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
          <v-tab-item id="allowed">
            <AllowedCurrency :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
          <v-tab-item id="agent"
            ><AgentFunction :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
          <v-tab-item id="deposit"
            ><DepositChannelVue :getCompanyDetails="getCompanyDetails" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <loading :active="loader" :opacity="0.9" color="#ff6b00" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import Companydetails from "./partnerTabs/Companydetails.vue";
import paymentMode from "./partnerTabs/paymentMode.vue";
import AgentFunction from "./partnerTabs/AgentFunction.vue";
import AllowedCurrency from "./partnerTabs/AllowedCurrency.vue";
import Otherdetails from "./partnerTabs/Otherdetails.vue";
import SettlementsdetailsVue from "./partnerTabs/Settlementsdetails.vue";
import DepositChannelVue from "./partnerTabs/DepositChannel.vue";
import alerts from "@/mixins/alerts";
// import { mapMutations } from "vuex";
// import Remarks from "./partnerTabs/Remarks.vue";
import Loading from "vue-loading-overlay";
export default {
  name: "Create Partner",
  components: {
    Companydetails,
    // Remarks,
    Loading,
    paymentMode,
    AgentFunction,
    Otherdetails,
    BreadCrumb,
    DepositChannelVue,
    AllowedCurrency,
    SettlementsdetailsVue,
  },
  mixins: [alerts],
  data() {
    return {
      currentItem: "",
      getCompanyDetails: null,
      showAdditionalTabs: false,
      stepcount: 1,
      loader: false,
      tabSeleted: 0,
      items: [
        { label: "Partner Info", key: "partner", disabled: false },
        {
          label: "Others",
          key: "others",
        },
        // {
        //   label: "Settlements",
        //   key: "settlements",
        // },
        {
          label: "Payment Mode",
          key: "payment",
        },
        {
          label: "Allowed Currency",
          key: "allowed",
        },
        {
          label: "Agent Function",
          key: "agent",
        },
        {
          label: "Deposit Channel",
          key: "deposit",
        },
      ],
    };
  },
  created() {
    const partnerId = this.$route.query.partner_id;
    console.log("partnerId", partnerId);
    this.showAdditionalTabs = !!partnerId;
  },
  computed: {
    filteredTabs() {
      if (this.showAdditionalTabs) {
        return this.items;
      } else {
        return this.items.filter((item) => item.key === "partner");
      }
    },
  },
  methods: {
    // ...mapMutations(["setcomponentName"]),
    exportpdf() {
      this.$store.dispatch("savecomponentName", "createPartner");
    },
    companyDetails(val) {
      if (val) {
        this.getCompanyDetails = val;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
